import Vue from 'vue';
import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
import moment from 'moment';

export default {
  namespaced: true,
  state: {
    participant: null,
    safeguardingStatus: null,
  },
  getters: {},
  mutations: {
    SET_PARTICIPANT(state, value) {
      state.participant = value;
    },
    SET_SAFEGUARDING_STATUS(state, value) {
      state.safeguardingStatus = value;
    },
  },
  actions: {
    setParticipant({ commit }, participant) {
      commit('SET_PARTICIPANT', participant);
    },
    // eslint-disable-next-line no-unused-vars
    async getParticipant({ commit, state, dispatch }, id) {
      // eslint-disable-next-line no-underscore-dangle
      await AdditionalVisitorsService.getAdditionalVisitor(id).then(res => {
        let person = res.data;
        let personNew =  {
          fullName: `${person.firstname} ${person.lastname}`,
          birthDateAndAge: `${moment(person.dob).format('DD/MM/YYYY')} (${moment(new Date()).diff(person.dob, 'years')})`,
          under18: parseInt(moment(new Date()).diff(person.dob, 'years'), 10) < 18,
          ...person
        };

        commit('SET_PARTICIPANT', personNew);

        if (personNew.under18) {
          dispatch('getSafeguardingStatus', id);
        }

        return personNew;
      }).catch(err => {
        console.log('error', err);
        Vue.$toast.error('Error getting the additional participant details. Please check your connection and refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
    async getSafeguardingStatus({ commit, state }, id) {
      // eslint-disable-next-line no-underscore-dangle
      await AdditionalVisitorsService.getAdditionalVisitorsSafeguardingStatus(id).then(res => {
        commit('SET_SAFEGUARDING_STATUS', res.data);

        return res.data;
      }).catch(() => {
        Vue.$toast.error('Error getting the  safeguarding status. Please check your connection and refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
  },
};
